import React from 'react';

import PropTypes from 'prop-types';

import { AutoCompleteField } from '../../../../constants/autocomplete-field';
import { CREDIT_CARD_FIELDS } from '../../constants';
import { CreditCardInput } from '../../credit-card-input';

export const CreditCardYear = ({ ignoreError = false }) => {
  return (
    <CreditCardInput autoComplete={AutoCompleteField.CCExpYear} field={CREDIT_CARD_FIELDS.CARD_EXPIRATION_YEAR} ignoreError={ignoreError} />
  );
};

CreditCardYear.propTypes = {
  ignoreError: PropTypes.bool,
};
